import React from "react";
import { Divider, List } from "@mui/material";

import MoreOptionsIconButton from "modules/common/components/buttons/moreOptionsIconButton";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";
import { ISMSListItem } from "./models";

interface ISMSOptionsProps {
    sms: ISMSListItem;
    onDownloadSMSActivity?: (sms: ISMSListItem) => void;
    onEditSMS?: (sms: ISMSListItem) => void;
    onPreviewSMS: (sms: ISMSListItem) => void;
    onDuplicateSMS: (sms: ISMSListItem) => void;
    onDeleteSMS?: (sms: ISMSListItem) => void;
    onUnsendSMS?: (sms: ISMSListItem) => void;
}

const SMSOptions: React.FC<ISMSOptionsProps> = ({
    sms,
    onDownloadSMSActivity,
    onEditSMS,
    onPreviewSMS,
    onDuplicateSMS,
    onDeleteSMS,
    onUnsendSMS
}) => {
    return <MoreOptionsIconButton>
        <List disablePadding>
            {
                sms.status === "draft"
                ? onEditSMS && <MoreOptionsItem
                    text="Continue editing"
                    onClick={() => onEditSMS(sms)}
                    buttonId="more-options-edit-button"
                />
                :  sms.status === "scheduled" 
                    ? onUnsendSMS && 
                    <MoreOptionsItem 
                        textStyle={{ color: "#B72026" }}
                        text="Cancel send"
                        onClick={() => onUnsendSMS(sms)}
                        buttonId="more-options-unpublish-button"
                    />
                    : onDownloadSMSActivity && 
                    <MoreOptionsItem
                        text="Download SMS activity"
                        onClick={() => onDownloadSMSActivity(sms)}
                        buttonId="more-options-download-activity-button"
                    />
            }
            <Divider light />
            <MoreOptionsItem
                text="Preview"
                onClick={() => onPreviewSMS(sms)}
                buttonId="more-options-preview-button"
            />
            <MoreOptionsItem
                text="Duplicate"
                onClick={() => onDuplicateSMS(sms)}
                buttonId="more-options-duplicate-button"
            />
            {
                onDeleteSMS &&
                <MoreOptionsItem
                    text="Delete"
                    textStyle={{ color: "#B72026" }}
                    onClick={() => onDeleteSMS(sms)}
                    buttonId="more-options-delete-button"
                />
            }
        </List>
    </MoreOptionsIconButton>;
};

export default SMSOptions;
